import { motion } from "framer-motion";
import styled from "styled-components";
import { InitialIcon } from "../../assets/Icons/InitialIcon";
import { T } from "../../styles/Theme";
import { useEffect, useState } from "react";
import { POSITION_RIGHT_VALID_URLS } from "../../env";
import TextValues from "../../TextValues/index.json";
import { InitialButtonImage } from "../../assets/Icons/InitialButtonImage";

interface StartButtonProps {
  modalOpen: boolean;
  close: () => void;
  open: () => void;
}

const StartButton = ({ modalOpen, close, open }: StartButtonProps) => {
  // const [position, setPosition] = useState<string>("right");

  useEffect(() => {
    const url = window.location.search.split("?")[1];
    // if (POSITION_RIGHT_VALID_URLS.has(url)) {
    //   setPosition("right");
    // } else {
    //   setPosition("left");
    // }
  }, [])
  
  const handleOnClick = () => {
    const url = window.location.search.split("?")[1];
    if (modalOpen) {
      window.parent.postMessage("collapse", url);
    } else {
      window.parent.postMessage("expand", url);
    }
    modalOpen ? close() : open();
    sessionStorage.setItem("tryadviser-opened", "true");
  };

  return (
    <>
      <StartButtonStyledLeft
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="buttonTrigger"
        onClick={handleOnClick}
      >
       <section className="_buttonImage">
          <InitialButtonImage />
        </section> 
        <div className="wraped-text">
          <span className="firstTitle">{TextValues.buttons.InitialButton}</span>
          <span className="subtitle">Descubre el plan ideal para ti</span>
        </div>
        <section className="iconSvg">
          <InitialIcon />
        </section>
      </StartButtonStyledLeft>
    </>
  );
};

const StartButtonStyledLeft = styled(motion.div)`
  box-shadow: 0px 10px 20px 0px #00000066;
  // animation: pulse-animation 2s infinite;

  .wraped-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
    margin-left: 2px;
    margin-bottom: 2px;
    width: 100%;
  }

  .firstTitle {
    font-size: 16px;
    font-weight: ${T.fontWeights.bold};
    text-align: left;
    padding-bottom: 1px;
    color: #FFFFFF;
  }

  .subtitle {
    position: relative;
    font-size: 10px;
    font-weight: 300;
    text-align: left;
    color: #FFFFFF;
  }

  .iconSvg {
    display: flex;
    justify-content: left;
    margin-bottom: 3px;
  }

  ._buttonImage {
    display: flex;
    // justify-content: left;
    margin-bottom: 3px;
  }

  svg {
    border-radius: 10%;
  }

  @media only screen and (max-width: 420px) {

    .firstTitle {
      font-size: 13px;
      font-weight: bold;
    }

    .subtitle {
      font-size: 8px;
    }
    
  }

  @keyframes pulse-animation {
    0% {
      box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
    }
    100% {
      box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
    }
  }

  position: fixed;
  bottom: 15px;
  left: 15px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 25px 10px 20px 15px;
  align-items: center;
  width: 260px;
  height: 65px;
  border-radius: 15px;
  background-color: ${T.primary};
`;

export default StartButton;
